import { styled, Stack } from '@mui/material'
import { theme } from 'theme'

export const StackStyled = styled(Stack)({
  alignItems: 'center',
  svg: { color: theme.palette['text-color'].secondary, fontSize: 13, cursor: 'pointer' }
})
